import AcSettlementDetailsDetailsTab from './details/details';
import AcSettlementSpecificationTab from './specification/specification';

export default {
  Details: AcSettlementDetailsDetailsTab,
  Specification: AcSettlementSpecificationTab,
};
